// import { useForm } from "@mantine/form";
import { useMutation } from "@tanstack/react-query";
import { updateBeginnerBonus } from "../../../../api/agencyAdmin/bonus";
import { notifications } from "@mantine/notifications";

const useCreate = () => {

    const createMutation = useMutation({
        mutationFn: updateBeginnerBonus,
        onSuccess: async (response) => {
            notifications.show({
                title: "Success",
                message: response?.message,
                color: "green",
                //  icon: "✅",
            });
        }
    })

    return { createMutation }

}

export default useCreate;
